import { render, staticRenderFns } from "./modeChange.vue?vue&type=template&id=563f5e1f&scoped=true"
import script from "./modeChange.vue?vue&type=script&lang=js"
export * from "./modeChange.vue?vue&type=script&lang=js"
import style0 from "./modeChange.vue?vue&type=style&index=0&id=563f5e1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f5e1f",
  null
  
)

export default component.exports